const TOPICS = [
  { title: '恋爱韩漫', desc: '甜蜜浪漫，心动不已的韩漫爱情故事合集', icon: 'ri-heart-line', count: '128部' },
  { title: '奇幻韩漫', desc: '异世界冒险与魔法奇幻题材韩漫精选', icon: 'ri-magic-line', count: '96部' },
  { title: '热血韩漫', desc: '燃爆激情的战斗与成长类韩漫汇总', icon: 'ri-fire-line', count: '84部' },
  { title: '悬疑韩漫', desc: '扣人心弦的推理悬疑韩漫作品导航', icon: 'ri-search-eye-line', count: '63部' },
  { title: '都市韩漫', desc: '现代都市背景下的职场与情感韩漫专题', icon: 'ri-building-line', count: '75部' },
  { title: '校园韩漫', desc: '青春校园题材韩漫作品集合入口', icon: 'ri-school-line', count: '58部' },
  { title: '古风韩漫', desc: '古典宫廷与历史题材韩漫专题索引', icon: 'ri-ink-bottle-line', count: '47部' },
  { title: '耽美韩漫', desc: '精选BL向优质韩漫作品导航合集', icon: 'ri-star-line', count: '112部' },
  { title: '全龄韩漫', desc: '适合全年龄段阅读的韩漫入门推荐', icon: 'ri-user-smile-line', count: '89部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            专题索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            按题材分类浏览韩漫网站资源，快速找到您喜欢的韩漫类型入口
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {TOPICS.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-start gap-4 p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors flex-shrink-0">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
                <span className="inline-block mt-2 text-xs text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full">
                  {item.count}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}